// extracted by mini-css-extract-plugin
export default {"header":"exampleModal_header__-yXnm","alert":"exampleModal_alert__pl9Fz","buttonsContainer":"exampleModal_buttonsContainer__ks-m6"};